import { NgModule } from '@angular/core';
import { MainCleanersComponent} from "./components/main-cleaners.component";
import { MainCleanerComponent} from "./components/main-cleaner.component";
import { SearchCleanersComponent} from "./components/dummy/search-cleaners.component";
import { CreateCleanersComponent} from "./components/dummy/create-cleaners.component";
import { ListCleanersComponent} from "./components/dummy/list-cleaners.component";
import { DataCleanerComponent} from "./components/dummy/data-cleaner.component";
import { DocCleanerComponent} from "./components/dummy/doc-cleaner.component";
import { AvailabilityCleanerComponent} from "./components/dummy/availability-cleaner.component";
import { RelatedDataCleanerComponent} from "./components/dummy/related-data-cleaner.component";
import { CommonModule } from '@angular/common';
import { CleanersRoutes } from './cleaners.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { CleanerService } from "../../injections/cleaner.service";
import { CleanersService } from "../../injections/cleaners.service";
import { FilterZoneSelected } from '../../pipes/filter-zone.pipe';
import {SharedModule} from "../../common/shared.module";
import { CleanerCommentsComponent } from './components/dummy/comments-cleaner.component';
import { CommentComponent } from './components/dummy/comment.component';


@NgModule({
    imports: [CommonModule,
    CleanersRoutes,
    JsonpModule,
    FormsModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    HttpModule,
    SharedModule],
    exports: [],
    declarations: [
        MainCleanersComponent, MainCleanerComponent, SearchCleanersComponent, CreateCleanersComponent,
        ListCleanersComponent,DataCleanerComponent,DocCleanerComponent,AvailabilityCleanerComponent, 
        FilterZoneSelected, RelatedDataCleanerComponent, CleanerCommentsComponent, CommentComponent
    ],
    providers: [CleanerService,CleanersService],
})
export class CleanersModule { }



// WEBPACK FOOTER //
// ./src/app/modules/cleaners/cleaners.module.ts